import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';
import { Icons } from '@ohif/ui-next';
import './Dashboard.css';

const Dashboard: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { logout } = useAuth();

  const dashboardTiles = [
    {
      id: 'studies',
      title: 'Study List',
      description: 'View and manage medical imaging studies',
      icon: '📋',
      color: 'blue',
      onClick: () => navigate('/studiesList', { state: { from: 'dashboard' } }),
    },
    {
      id: 'reports',
      title: 'Reports',
      description: 'Generate and view medical reports',
      icon: '📊',
      color: 'green',
      onClick: () => navigate('/reports'),
    },
    {
      id: 'submissions',
      title: 'Job List',
      description: 'View ophthalmology studies and measurements',
      icon: '👁️',
      color: 'purple',
      onClick: () => navigate('/submissions', { state: { from: 'dashboard' } }),
    },
    {
      id: 'settings',
      title: 'Settings',
      description: 'Configure application preferences',
      icon: '⚙️',
      color: 'orange',
      onClick: () => navigate('/settings'),
    },
    {
      id: 'users',
      title: 'User Management',
      description: 'Manage user accounts and permissions',
      icon: '👥',
      color: 'red',
      onClick: () => navigate('/users'),
    },
    {
      id: 'help',
      title: 'Help & Support',
      description: 'Access documentation and support',
      icon: '❓',
      color: 'teal',
      onClick: () => navigate('/help'),
    },
  ];

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <div className="header-content">
          <div>
            <h1>Dashboard</h1>
            <p>Welcome to Retina Reading Center. Select an option below to get started.</p>
          </div>
          <button
            className="logout-button"
            onClick={async () => {
              console.log('Logout button clicked');
              await logout();
              navigate('/login');
            }}
            title="Logout"
          >
            <Icons.PowerOff />
          </button>
        </div>
      </div>

      <div className="dashboard-grid">
        {dashboardTiles.map(tile => (
          <div
            key={tile.id}
            className={`dashboard-tile ${tile.color}`}
            onClick={tile.onClick}
          >
            <div className="tile-icon">{tile.icon}</div>
            <div className="tile-content">
              <h3>{tile.title}</h3>
              <p>{tile.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Dashboard;
